import { useState, useEffect, useRef } from "react";
import { Card, Button, Row, Col, Form, Dropdown } from "react-bootstrap";
import { GoTrash } from "react-icons/go";
import { BsThreeDots } from "react-icons/bs";
import { BiCopy } from "react-icons/bi";
import { FiPlus, FiArrowUp, FiArrowDown, FiTrash } from "react-icons/fi";
import './Sondaggi.css';

export default function DomandaSondaggio(props) {
    const [mostraPunteggio, setMostraPunteggio] = useState(false);
    const testoInputRefs = useRef([]); // Per il focus sull'input di testo
    const puntiInputRefs = useRef([]); // Per il listener wheel sull'input dei punti
    const prevOpzioniLength = useRef(props.domanda.opzioniRisposta?.length || 0);
    const [minMaxErrors, setMinMaxErrors] = useState({ min: null, max: null }); // Stato locale per errori min/max

    const [duplicateOptionIndices, setDuplicateOptionIndices] = useState(new Set()); // Stato per controllare gli indici delle opzioni al fine di verificare se ci sianopiù opzioni con lo stesso testo in una stessa domanda (Set per efficienza)

    const minInputRef = useRef(null);
    const maxInputRef = useRef(null);

    useEffect(() => {
        const haAlmenoUnTestoValido = (props.domanda.opzioniRisposta || []).some(
            opz => opz.opzRisTesto && opz.opzRisTesto.trim() !== ''
        );

        //Controlla se ci sono errori per le opzioni di questa domanda specifica
        const hasGeneralOptionError = props.erroriDomande?.opzioni;

        if (hasGeneralOptionError && haAlmenoUnTestoValido) {
            props.clearErroreDomanda("opzioni", props.sezioneIndex, props.index);
        }
    }, [
        props.domanda.opzioniRisposta,
        props.erroriDomande?.opzioni,
        props.clearErroreDomanda,
        props.sezioneIndex,
        props.index
    ]);


    // useEffect per aggiungere/rimuovere i listener NON passivi
    // useEffect per aggiungere/rimuovere i listener wheel (usa puntiInputRefs)
    useEffect(() => {
        // Usa puntiInputRefs qui
        const currentPuntiRefs = puntiInputRefs.current;
        const currentMinRef = minInputRef.current;
        const currentMaxRef = maxInputRef.current;
        const listenerOptions = { passive: false };

        const refsToListen = [];
        const listeningElements = new Set();

        // Itera sui ref dei PUNTI
        currentPuntiRefs.forEach((input, index) => {
            if (input && !listeningElements.has(input)) {
                refsToListen.push(input);
                listeningElements.add(input);
            }
        });
        // Aggiungi Min/Max se esistono
        if (currentMinRef && !listeningElements.has(currentMinRef)) {
            refsToListen.push(currentMinRef);
            listeningElements.add(currentMinRef);
        }
        if (currentMaxRef && !listeningElements.has(currentMaxRef)) {
            refsToListen.push(currentMaxRef);
            listeningElements.add(currentMaxRef);
        }

        refsToListen.forEach(ref => {
            ref.addEventListener('wheel', handleWheel, listenerOptions);
        });

        // Funzione di cleanup
        return () => {
            refsToListen.forEach(ref => {
                ref.removeEventListener('wheel', handleWheel);
            });
        };
    }, [props.domanda.opzioniRisposta.length, props.domanda.tipDomMultipla]);

    useEffect(() => {
        checkDuplicateOptions(props.domanda.opzioniRisposta || []);
    }, [props.domanda.opzioniRisposta]);

    //FUNZIONE che controlla se l'opzione ha una condizione attiva
    const calcolaCondizioneAttiva = () => {
        const opzioniCorrenti = props.domanda.opzioniRisposta || [];
        return opzioniCorrenti.some(
            opz => (opz.opzRisSezSuccessiva !== null && opz.opzRisSezSuccessiva !== undefined && opz.opzRisSezSuccessiva !== '') || opz.opzRisFlTermina === true
        );
    };

    //FUNZIONE che controlla se ci sono opzioni con stesso testo 
    const checkDuplicateOptions = (currentOptions) => {
        const textCounts = {}; //oggetto per contare le occorrenze di ogni testo
        const duplicates = new Set(); // set per gli indici duplicati
        // conta le occorrenze di ogni testo (ignorando minuscole/maiuscole e spazi extra)
        currentOptions.forEach(opz => {
            const text = (opz.opzRisTesto || '').trim().toLowerCase();
            if (text) { //ignora i testi vuoti
                textCounts[text] = (textCounts[text] || 0) + 1;
            }
        })

        // Identifica gli indici delle opzioni il cui testo appare più di una volta
        currentOptions.forEach((opz, index) => {
            const text = (opz.opzRisTesto || '').trim().toLowerCase();
            if (text && textCounts[text] > 1) {
                duplicates.add(index);
            }
        });
        setDuplicateOptionIndices(duplicates);
    }

    const validateMinMax = (fieldName, value, currentMin, currentMax, numOpzioni, isObbligatoria) => {
        const numValue = parseInt(value, 10);
        let error = null;

        if (isNaN(numValue) || numValue < 0) {
            // Permetti campo vuoto o null, ma non negativi o NaN se non vuoto
            if (value !== '' && value !== null && value !== undefined) {
                error = "Inserire un numero valido (>= 0)";
            }
        } else {
            if (fieldName === 'min') {
                // Validazione MINIMO
                if (isObbligatoria && numValue < 1) {
                    error = "Minimo 1 per domande obbligatorie";
                }
                if (!isObbligatoria && numOpzioni > 0 && numValue >= numOpzioni) {
                    // Se non obbligatoria, min può essere 0, ma non >= numOpzioni
                    error = `Minimo deve essere < ${numOpzioni}`;
                }
                // Controlla anche rispetto al massimo CORRENTE
                if (currentMax !== null && numValue > currentMax) {
                    error = "Minimo non può superare il massimo";
                }
            } else if (fieldName === 'max') {
                // Validazione MASSIMO
                if (numValue > numOpzioni) {
                    error = `Massimo non può superare ${numOpzioni} (numero opzioni)`;
                }
                // Controlla anche rispetto al minimo CORRENTE
                if (currentMin !== null && numValue < currentMin) {
                    error = "Massimo non può essere inferiore al minimo";
                }
                // Se max è 0 e ci sono opzioni, non ha senso
                if (numOpzioni > 0 && numValue === 0) {
                    error = "Massimo deve essere almeno 1";
                }
            }
        }
        return error;
    };


    // Funzione  per determinare la classe di validazione per il campo domDomanda
    const getDomandaValidationClass = () => {
        // Se la validazione globale non è ancora attiva, non mostrare nulla
        if (!props.validato) {
            return '';
        }
        // Se la validazione è attiva, controlla se c'è un errore specifico
        if (props.erroriDomande?.domDomanda) {
            return 'is-invalid'; // C'è un errore -> rosso
        } else {
            return 'is-valid'; // Non c'è errore -> verde
        }
    };

    useEffect(() => {
        setMostraPunteggio(props.punteggioAttivo);
    }, [props.punteggioAttivo]);

    const handleChange = (field, value) => {
        props.setDomandaField(field, value, props.index);
    };

    const handleTipoDomandaChange = (isMultipla) => {
        const domandaAttuale = props.domanda;

        let nuovoMin = null;
        let nuovoMax = null;

        if (isMultipla) {
            nuovoMin = domandaAttuale.domObbligatoria ? 1 : 0;
            nuovoMax = 1;
        }

        const nuovaDomanda = {
            ...domandaAttuale,
            tipDomMultipla: isMultipla,
            tipDomMinRisposte: isMultipla ? nuovoMin : null,
            tipDomMaxRisposte: isMultipla ? nuovoMax : null,
        };

        props.setDomandaCompleta(nuovaDomanda, props.index);
    };

    // Funzione handleWheel con logging
    const handleWheel = (event) => {
        if (event.target.type === 'number' && document.activeElement === event.target) {
            event.preventDefault();
            event.stopPropagation();
        } else {
        }
    };

    // useEffect per aggiungere/rimuovere i listener NON passivi con logging
    useEffect(() => {
        const currentPuntiRefs = puntiInputRefs.current;
        const currentMinRef = minInputRef.current;
        const currentMaxRef = maxInputRef.current;
        const listenerOptions = { passive: false };

        const refsToListen = [];
        const listeningElements = new Set(); // Usa Set per sicurezza

        // Itera sui ref dei PUNTI
        currentPuntiRefs.forEach((input, index) => { // <-- Usa currentPuntiRefs
            if (input && !listeningElements.has(input)) {
                // console.log(`Adding listener to Punti input index ${index}`, input); // Log opzionale
                refsToListen.push(input);
                listeningElements.add(input);
            }
        });
        // Aggiungi Min/Max se esistono
        if (currentMinRef && !listeningElements.has(currentMinRef)) {
            // console.log("Adding listener to Min input", currentMinRef); // Log opzionale
            refsToListen.push(currentMinRef);
            listeningElements.add(currentMinRef);
        }
        if (currentMaxRef && !listeningElements.has(currentMaxRef)) {
            // console.log("Adding listener to Max input", currentMaxRef); // Log opzionale
            refsToListen.push(currentMaxRef);
            listeningElements.add(currentMaxRef);
        }

        refsToListen.forEach(ref => {
            ref.addEventListener('wheel', handleWheel, listenerOptions);
        });

        // Funzione di cleanup
        return () => {
            // console.log("Effect cleanup: Removing listeners. Refs count:", refsToListen.length); // Log opzionale
            refsToListen.forEach(ref => {
                // console.log("Removing listener from", ref); // Log opzionale
                ref.removeEventListener('wheel', handleWheel);
            });
        };
        // Le dipendenze rimangono le stesse
    }, [props.domanda.opzioniRisposta.length, props.domanda.tipDomMultipla]);

    const handleOpzioneChange = (idx, field, value) => {
        props.modificaOpzione(idx, field, value);
        const simulatedNuoveOpzioni = props.domanda.opzioniRisposta.map((opz, index) => {
            if (index === idx) {
                return { ...opz, [field]: value };
            }
            return opz;
        });
        if (field === "opzRisTesto") {
            checkDuplicateOptions(simulatedNuoveOpzioni);
        }
    };

    const handleToggleObbligatoria = () => {
        const nuovaObbligatoria = !props.domanda.domObbligatoria;
        let nuovoMinimo = props.domanda.tipDomMinRisposte; // Inizia con il valore attuale

        if (nuovaObbligatoria) {
            // Se diventa OBBLIGATORIA, assicura che il minimo sia almeno 1.
            if (nuovoMinimo === null || nuovoMinimo < 1) {
                nuovoMinimo = 1;
            }
            // Se era già >= 1, non fare nulla al minimo.
        } else {
            // Se diventa NON OBBLIGATORIA, il minimo diventa 0.
            nuovoMinimo = 0;
        }
        // Crea oggetto domanda aggiornato
        const nuovaDomanda = {
            ...props.domanda,
            domObbligatoria: nuovaObbligatoria,
            tipDomMinRisposte: nuovoMinimo
        };
        // Chiama la prop per aggiornare l'intera domanda nel genitore
        props.setDomandaCompleta(nuovaDomanda, props.index);
    };

    const aggiungiOpzione = () => {
        // Pass indices needed by the parent handler
        props.aggiungiOpzione(props.sezioneIndex, props.index);
    };

    const handleMinMaxChange = (field, rawValue) => {
        const { tipDomMinRisposte, tipDomMaxRisposte, domObbligatoria } = props.domanda;
        const numOpzioni = props.domanda.opzioniRisposta.length;
    
        let parsedValue = parseInt(rawValue, 10);
        let error = null;
        let isSyntacticallyValid = false;

        // 1. Validazione Sintattica Base
        if (rawValue === '' || rawValue === null) {
            parsedValue = null;
            isSyntacticallyValid = true;
        } else if (!isNaN(parsedValue) && parsedValue >= 0) {
            isSyntacticallyValid = true;
        } else {
            error = "Inserire un numero valido (>= 0)";
        }

        // 2. Validazione di Range (solo se sintatticamente valido)
        if (isSyntacticallyValid && parsedValue !== null) {
             const currentMinForValidation = field === 'tipDomMaxRisposte' ? tipDomMinRisposte : parsedValue;
             const currentMaxForValidation = field === 'tipDomMinRisposte' ? tipDomMaxRisposte : parsedValue;
 

            // Passa lo stato OBBLIGATORIA ATTUALE per validare i range correttamente
            const rangeError = validateMinMax(
                field === 'tipDomMinRisposte' ? 'min' : 'max',
                rawValue,
                currentMinForValidation,
                currentMaxForValidation,
                numOpzioni,
                domObbligatoria // Usa lo stato attuale qui
            );
            if (rangeError) {
                error = rangeError;
            }
        }

        // Aggiorna errori locali (mostra errori sintattici o di range)
        setMinMaxErrors(prev => ({
            ...prev,
            [field === 'tipDomMinRisposte' ? 'min' : 'max']: error
        }));

        // 3. Determina i nuovi valori e aggiorna il genitore (SOLO se sintatticamente valido)
        if (isSyntacticallyValid) {
            let finalValue = parsedValue; // null o numero >= 0

            let newMinValue = field === 'tipDomMinRisposte' ? finalValue : tipDomMinRisposte;
            let newMaxValue = field === 'tipDomMaxRisposte' ? finalValue : tipDomMaxRisposte;
            let newObbligatoriaValue;
    
            // Sincronizzazione basata sul NUOVO valore del minimo
            newObbligatoriaValue = newMinValue !== null && newMinValue >= 1;

            // Crea l'oggetto domanda aggiornato
            const nuovaDomanda = {
                ...props.domanda,
                tipDomMinRisposte: newMinValue,
                tipDomMaxRisposte: newMaxValue,
                domObbligatoria: newObbligatoriaValue
            };

            // Chiama la prop per aggiornare l'intera domanda nel genitore
            props.setDomandaCompleta(nuovaDomanda, props.index);
        }
        // Se non è sintatticamente valido, non aggiorniamo il genitore
    };

    const eliminaOpzione = (idx) => {
        props.eliminaOpzione(props.sezioneIndex, props.index, idx);
        const opzioniRimanenti = props.domanda.opzioniRisposta.filter((_, index) => index !== idx);
        checkDuplicateOptions(opzioniRimanenti);
    }

    const spostaOpzioneSu = (index) => {
        if (index === 0) return;
        const nuoveOpzioni = [...props.domanda.opzioniRisposta];
        [nuoveOpzioni[index - 1], nuoveOpzioni[index]] = [nuoveOpzioni[index], nuoveOpzioni[index - 1]];
        nuoveOpzioni.forEach((opz, i) => opz.opzRisPosizione = i + 1);
        props.setDomandaField("opzioniRisposta", nuoveOpzioni, props.index);
    };

    const spostaOpzioneGiu = (index) => {
        if (index === props.domanda.opzioniRisposta.length - 1) return;
        const nuoveOpzioni = [...props.domanda.opzioniRisposta];
        [nuoveOpzioni[index + 1], nuoveOpzioni[index]] = [nuoveOpzioni[index], nuoveOpzioni[index + 1]];
        nuoveOpzioni.forEach((opz, i) => opz.opzRisPosizione = i + 1);
        props.setDomandaField("opzioniRisposta", nuoveOpzioni, props.index);
    };

    const [openDropdownIndex, setOpenDropdownIndex] = useState(null);

    // Funzione per gestire apertura/chiusura
    const handleDropdownToggle = (isOpen, index) => {
        if (isOpen) {
            setOpenDropdownIndex(index);
        } else {
            // Solo se si sta chiudendo quello che era aperto
            if (openDropdownIndex === index) {
                setOpenDropdownIndex(null);
            }
        }
    };

    const handleVaiAllaDomandaToggle = () => {
        // Calcola il nuovo stato desiderato basandosi sullo stato ATTUALE delle condizioni
        const condizioniAttualmenteAttive = calcolaCondizioneAttiva();
        const nuovoStatoToggle = !condizioniAttualmenteAttive; // Se erano attive -> disattiva, se erano disattive -> attiva

        let opzioniAggiornate;

        if (nuovoStatoToggle) { // Se stiamo ATTIVANDO le condizioni
            const sezioniOrdinate = [...(props.sezioni || [])].sort((a, b) => a.sezPosizione - b.sezPosizione);
            const nextSection = sezioniOrdinate.find(s => s.sezPosizione > props.sezioneCorrentePosizione);
            opzioniAggiornate = (props.domanda.opzioniRisposta || []).map(opz => {
                let defaultSezSuccessiva = null;
                let defaultFlTermina = false;
                if (nextSection) {
                    defaultSezSuccessiva = nextSection.sezId || nextSection.sezPosizione;
                } else {
                    defaultFlTermina = true;
                }
                return { ...opz, opzRisSezSuccessiva: defaultSezSuccessiva, opzRisFlTermina: defaultFlTermina };
            });
        } else { // Se stiamo DISATTIVANDO le condizioni
            opzioniAggiornate = (props.domanda.opzioniRisposta || []).map(opz => ({
                ...opz,
                opzRisSezSuccessiva: null,
                opzRisFlTermina: false
            }));
        }
        // Aggiorna l'intera domanda nel genitore
        props.setDomandaField("opzioniRisposta", opzioniAggiornate, props.index);
        // Rimuovi la riga seguente se era presente:
        // setMostraDropdownDomande(newState);
    };


    // useEffect per il focus (usa testoInputRefs)
    useEffect(() => {
        // Usa testoInputRefs qui per il focus
        if (props.domanda.opzioniRisposta.length > prevOpzioniLength.current) {
            const lastIndex = props.domanda.opzioniRisposta.length - 1;
            setTimeout(() => {
                // Accedi all'array corretto
                const input = testoInputRefs.current[lastIndex];
                if (input) input.focus();
            }, 0);
        }
        prevOpzioniLength.current = props.domanda.opzioniRisposta.length;
    }, [props.domanda.opzioniRisposta.length]); // Dipende solo dalla lunghezza


    // Funzione helper per la validazione del testo dell'opzione
    const getOpzioneValidationClass = (optionIndex) => {

        if (!props.validato) {
            return '';
        }
        // C'è un errore specifico per il testo di questa opzione
        console.log(props.domanda.opzioniRisposta?.[optionIndex]?.opzRisTesto)
        if (props.erroriDomande?.opzioniRisposta?.[optionIndex]?.opzRisTesto || props.domanda.opzioniRisposta?.[optionIndex]?.opzRisTesto.trim() === "") {
            return 'is-invalid';
        } else {
            // Non c'è errore, quindi è valido 
            return 'is-valid';
        }
    };


    const getOpzioneWarningClass = (index) => {
        return duplicateOptionIndices.has(index) ? 'is-warning' : '';
    };

    const calculateColSizes = () => {
        const hasPunteggio = mostraPunteggio;
        const hasCondizione = showVaiAllaDropdowns; // <-- Usa la variabile calcolata
        const colCondizione = hasCondizione ? 4 : 0;
        const colPunteggio = hasPunteggio ? 2 : 0;
        let colRisposta = 12 - colCondizione - colPunteggio;
        colRisposta = Math.max(colRisposta, 6);
        return { colRisposta, colCondizione, colPunteggio };
    };

    // --- CALCOLO VISIBILITÀ DIRETTAMENTE NEL RENDER ---
    const isVaiAllaAttiva = calcolaCondizioneAttiva();
    const showVaiAllaDropdowns = !props.domanda.tipDomMultipla && isVaiAllaAttiva;
    const switchVaiAllaChecked = !props.domanda.tipDomMultipla && isVaiAllaAttiva;




    return (
        <Card className="my-3 bordi-arrotondati"
            id={`domanda-${props.sezioneIndex}-${props.index}`}
        >
            <Card.Body className="p-0">
                <Row className="g-0">
                    {/* Colonna contenuto */}
                    <Col md={9} className="p-4">
                        <Row className="mb-2 align-items-center">
                            <Col className="d-flex align-items-center gap-2">
                                <strong>Domanda {props.domanda.domNumPosizione}: </strong> {props.mandatoryField()}
                                {/*<Button
      size="sm"
      variant="light"
      onClick={() => props.muoviDomanda(props.index, "up")}
      disabled={props.index === 0}
    >
      ↑
    </Button>
    <Button
      size="sm"
      variant="light"
      onClick={() => props.muoviDomanda(props.index, "down")}
      disabled={props.index === props.domande?.length - 1}
    >
      ↓
    </Button>*/}

                                {/* Drag handle spinto a destra */}
                                <div
                                    {...props.dragHandleProps}
                                    className="ms-auto"
                                    style={{
                                        cursor: "grab",
                                        fontSize: "1.4rem",
                                        padding: "0.2rem 0.5rem",
                                        userSelect: "none"
                                    }}
                                    title="Trascina per riordinare"
                                >
                                    ⋮⋮
                                </div>
                            </Col>
                        </Row>

                        <Form.Group className="mb-3">
                            <Form.Control
                                as="textarea"
                                rows={2}
                                placeholder="Testo della domanda"
                                className={`bordi-arrotondati-form-domanda ${getDomandaValidationClass()}`}
                                value={props.domanda.domDomanda}
                                onChange={(e) => handleChange("domDomanda", e.target.value)}
                            />
                            {props.erroriDomande?.domDomanda && (
                                <Form.Control.Feedback type="invalid">
                                    {props.erroriDomande.domDomanda}
                                </Form.Control.Feedback>
                            )}
                        </Form.Group>


                        {(props.domanda.opzioniRisposta || []).map((opz, i) => {
                            const { colRisposta, colCondizione, colPunteggio } = calculateColSizes();
                            const hasPunteggio = colPunteggio > 0;
                            // Usa la variabile calcolata per mostrare/nascondere
                            const hasCondizione = showVaiAllaDropdowns; // <-- Usa la variabile calcolata


                            return (
                                <Row key={i} className="align-items-start mb-2">
                                    <Col md={colRisposta} >
                                        {i === 0 && <Form.Label className="fw-bold mb-1">Opzioni di risposta {props.mandatoryField()}</Form.Label>}
                                        <div className="position-relative"
                                            style={{ zIndex: openDropdownIndex === i ? 20 : 1 }} // <-- Z-INDEX DINAMICO
                                        >
                                            <Form.Control
                                                type="text"
                                                placeholder={` Risposta ${i + 1}`}
                                                className={`bordi-arrotondati-form-domanda form-control-opzione ${getOpzioneValidationClass(i)} ${getOpzioneWarningClass(i)}`}
                                                value={opz.opzRisTesto}
                                                onChange={(e) => {

                                                    handleOpzioneChange(i, "opzRisTesto", e.target.value)
                                                }
                                                }
                                                style={{ paddingLeft: "2.2rem", paddingRight: "2.5rem", overscrollBehavior: 'contain' }}
                                                ref={(el) => (testoInputRefs.current[i] = el)}
                                                aria-describedby={props.erroriDomande?.opzioniRisposta?.[i]?.opzRisTesto ? `feedback-opzione-${i}` : undefined}
                                            />

                                            {/* Checkbox o radio */}
                                            <div className="position-absolute top-50 start-0 translate-middle-y ps-2">
                                                <Form.Check
                                                    type={props.domanda.tipDomMultipla ? "checkbox" : "radio"}
                                                    disabled
                                                />
                                            </div>
                                            {/* Dropdown tre puntini */}
                                            <div
                                                className="custom-dropdown-tre-puntini position-absolute top-50 end-0 translate-middle-y pe-1" // pe-1 per avvicinarlo
                                                style={{ zIndex: 3 }} // Sopra l'icona check/radio
                                            >
                                                <Dropdown align="end" drop="down" popperConfig={{ strategy: 'fixed' }}
                                                    onToggle={(isOpen) => handleDropdownToggle(isOpen, i)}>
                                                    <Dropdown.Toggle variant="light" size="sm" className="p-0 border-0 shadow-none bg-transparent no-caret">
                                                        <BsThreeDots />
                                                    </Dropdown.Toggle>

                                                    <Dropdown.Menu renderOnMount style={{ zIndex: 1090 }}> {/* zIndex alto per il menu */}
                                                        <Dropdown.Item onClick={() => aggiungiOpzione()}>
                                                            <FiPlus className="me-2 text-dark" />
                                                            Aggiungi risposta
                                                        </Dropdown.Item>
                                                        <Dropdown.Item onClick={() => spostaOpzioneSu(i)}>
                                                            <FiArrowUp className="me-2 text-dark" />
                                                            Sposta su
                                                        </Dropdown.Item>
                                                        <Dropdown.Item onClick={() => spostaOpzioneGiu(i)}>
                                                            <FiArrowDown className="me-2 text-dark" />
                                                            Sposta giù
                                                        </Dropdown.Item>
                                                        <Dropdown.Divider />
                                                        <Dropdown.Item className="text-danger" onClick={() => eliminaOpzione(i)}>
                                                            <FiTrash className="me-2 text-danger" />
                                                            Elimina risposta
                                                        </Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>
                                        </div>
                                        <div
                                            id={`feedback-opzione-${i}`} // ID per aria-describedby
                                            className="invalid-feedback"
                                            // Controlla esplicitamente la visualizzazione
                                            style={{ display: props.erroriDomande?.opzioniRisposta?.[i]?.opzRisTesto ? 'block' : 'none' }}
                                        >
                                            {props.erroriDomande?.opzioniRisposta?.[i]?.opzRisTesto}
                                        </div>


                                    </Col>

                                    {showVaiAllaDropdowns && (
                                        <Col md={colCondizione}>
                                            {/* INTESTAZIONE SOLO PER LA PRIMA RIGA */}
                                            {i === 0 && <Form.Label className="fw-bold mb-1">Vai a sezione</Form.Label>}
                                            <Form.Select
                                                className="bordi-arrotondati-form-domanda"
                                                value={opz.opzRisFlTermina ? "invia" : opz.opzRisSezSuccessiva || ""}
                                                onChange={(e) => {
                                                    const val = e.target.value;
                                                    if (val === "invia") {
                                                        props.modificaOpzione(i, "opzRisSezSuccessiva", null);
                                                        props.modificaOpzione(i, "opzRisFlTermina", true);
                                                    } else {
                                                        props.modificaOpzione(i, "opzRisSezSuccessiva", val);
                                                        props.modificaOpzione(i, "opzRisFlTermina", false);
                                                    }
                                                }}
                                            >

                                                {props.sezioni
                                                    ?.filter((s) => s.sezPosizione > props.sezioneCorrentePosizione) // solo quelle dopo
                                                    .map((s, idx) => (
                                                        <option key={s.sezPosizione} value={s.sezId || s.sezPosizione}>
                                                            Sez. {s.sezPosizione}{s.sezNome ? `: ${s.sezNome.substring(0, 15)}...` : ''}
                                                        </option>
                                                    ))}

                                                <option value="invia">Invia sondaggio</option>
                                            </Form.Select>
                                        </Col>
                                    )}
                                    {/* Colonna punti */}
                                    {hasPunteggio && (
                                        <Col md={colPunteggio}>
                                            {/* INTESTAZIONE SOLO PER LA PRIMA RIGA */}
                                            {i === 0 && <Form.Label className="fw-bold mb-1">Punti</Form.Label>}
                                            <Form.Control
                                                type="text" // <-- Cambiato da "number"
                                                inputMode="numeric" // Suggerisce tastiera numerica su mobile
                                                pattern="[0-9]*" // Pattern HTML5 (validazione base)
                                                placeholder="Punti"
                                                className="bordi-arrotondati-form-domanda"
                                                value={opz.opzRisPunteggio ?? ''} // Mostra il valore (o stringa vuota)
                                                ref={(el) => (puntiInputRefs.current[i] = el)} // Il ref serve ancora? Forse no per wheel.
                                                onChange={(e) => {
                                                    const rawValue = e.target.value;
                                                    // Permetti solo numeri o stringa vuota
                                                    if (/^\d*$/.test(rawValue)) {
                                                        const finalValue = rawValue === '' ? null : parseInt(rawValue, 10);
                                                        // Chiamata alla funzione di update del genitore
                                                        handleOpzioneChange(i, "opzRisPunteggio", finalValue);
                                                    }
                                                    // Altrimenti ignora l'input non numerico
                                                }}
                                            />
                                        </Col>
                                    )}

                                    {/* Colonna condizione */}

                                </Row>
                            );
                        })}
                        {props.erroriDomande?.opzioni && (
                            <div className="text-danger mt-2">
                                <strong>{props.erroriDomande.opzioni}</strong>
                            </div>
                        )}


                        {/* Bottone SEMPRE visibile alla fine */}
                        <Row>
                            <Col>
                                <Button
                                    size="sm"
                                    variant="outline-primary"
                                    className="mt-2"
                                    onClick={aggiungiOpzione}
                                >
                                    Aggiungi risposta +
                                </Button>
                            </Col>
                        </Row>
                    </Col>

                    {/* Colonna impostazioni */}
                    <Col
                        md={3}
                        className="bg-light position-relative d-flex flex-column bordi-arrotondati-end border-start"
                        style={{ padding: "1rem" }}
                    >                    {/* Bottone Elimina in alto a destra */}
                        <div className="position-absolute top-0 end-0 m-2 d-flex gap-2">
                            <Button
                                variant="secondary"
                                className="btn-sm"
                                onClick={() => props.duplicaDomanda(props.index)}
                                title="Duplica domanda"
                            >
                                <BiCopy color="white" />
                            </Button>
                            <Button
                                variant="danger"
                                className="btn-sm"
                                onClick={() => props.handleDeleteDomanda(props.domanda)}
                                title="Elimina domanda"
                            >
                                <GoTrash color="white" />
                            </Button>
                        </div>


                        {/* Tipo di domanda */}
                        <Form.Label className="mt-4"><strong>Tipo di domanda</strong></Form.Label>
                        <Form.Select
                            className="mb-3 bordi-arrotondati-form-domanda"
                            value={props.domanda.tipDomMultipla ? "multipla" : "singola"}
                            onChange={(e) => handleTipoDomandaChange(e.target.value === "multipla")}
                        >
                            <option value="singola">Scelta singola</option>
                            <option value="multipla">Scelta multipla</option>
                        </Form.Select>

                        {/* Se multipla, mostra Min/Max risposte */}
                        {props.domanda.tipDomMultipla && (
                            <div className="mb-3">
                                <Form.Label><strong>Numero di risposte consentite</strong></Form.Label>
                                <Row>
                                    <Col>
                                        <Form.Label>Minimo</Form.Label>
                                        <Form.Control
                                            type="number"
                                            ref={minInputRef} // Assegna ref

                                            min={props.domanda.domObbligatoria ? 1 : 0}
                                            max={
                                                props.domanda.domObbligatoria
                                                    ? Math.max(props.domanda.opzioniRisposta.length - 1, 1)
                                                    : Math.max(props.domanda.opzioniRisposta.length - 1, 0)
                                            }
                                            value={props.domanda.tipDomMinRisposte ?? ""}
                                            size="sm" className={`bordi-arrotondati-form-domanda ${props.erroriDomande?.tipDomMinRisposte ? "is-invalid" : ""}`}

                                            onChange={(e) => handleMinMaxChange("tipDomMinRisposte", e.target.value)} />
                                        {props.erroriDomande?.tipDomMinRisposte && (
                                            <Form.Control.Feedback type="invalid">
                                                {props.erroriDomande.tipDomMinRisposte}
                                            </Form.Control.Feedback>
                                        )}
                                    </Col>
                                    <Col>
                                        <Form.Label>Massimo</Form.Label>
                                        <Form.Control
                                            size="sm"
                                            ref={maxInputRef} // Assegna ref

                                            className={`bordi-arrotondati-form-domanda ${props.erroriDomande?.tipDomMaxRisposte ? "is-invalid" : ""}`}
                                            type="number"
                                            min={props.domanda.tipDomMinRisposte == 0 ? 1 : props.domanda.tipDomMinRisposte}
                                            max={props.domanda.opzioniRisposta.length}
                                            value={props.domanda.tipDomMaxRisposte ?? ""}
                                            onChange={(e) => handleMinMaxChange("tipDomMaxRisposte", e.target.value)} />
                                        {props.erroriDomande?.tipDomMaxRisposte && (
                                            <Form.Control.Feedback type="invalid">
                                                {props.erroriDomande.tipDomMaxRisposte}
                                            </Form.Control.Feedback>
                                        )}

                                    </Col>
                                </Row>

                            </div>
                        )}


                        {/* Domanda obbligatoria */}
                        <Form.Check
                            type="switch"
                            label="Domanda obbligatoria"
                            className="mb-3"
                            checked={props.domanda.domObbligatoria}
                            onChange={handleToggleObbligatoria}
                        />


                        {/* Switch per attivare/disattivare condizione */}
                        {
                            !props.domanda.tipDomMultipla && (
                                <Form.Check
                                    type="switch"
                                    label="Vai alla sezione..."
                                    className="mb-3"
                                    checked={switchVaiAllaChecked}
                                    onChange={handleVaiAllaDomandaToggle}
                                />
                            )
                        }

                    </Col>



                </Row>
            </Card.Body>
        </Card>
    );
}
